import { TabsContent } from '@wellesley/ui'
import { FC, RefObject } from 'react'
import { NotificationItem, NotificationBody } from '@wellesley/notifications'

type ListProps = {
  containerRef: RefObject<HTMLUListElement>
  visibleCount: number | null
  listMaxHeight: string
  tabValue: 'all' | 'unread'
  notifications?: NotificationItem[] | null
}

const NotificationsList: FC<ListProps> = ({
  notifications,
  containerRef,
  visibleCount,
  listMaxHeight,
  tabValue,
}) => {
  const hasNotifications = notifications && notifications.length > 0

  return (
    <TabsContent value={tabValue}>
      {hasNotifications ? (
        <ul
          ref={containerRef}
          className="pt-xs"
          style={{
            maxHeight: listMaxHeight,
          }}
        >
          {notifications
            ?.slice(0, visibleCount ?? notifications.length)
            .map((n) => (
              <li key={n.id} className="px-xxs">
                <NotificationBody notification={n} isPopup={true} />
              </li>
            ))}
        </ul>
      ) : (
        <div className="flex h-full items-center justify-center">
          <p className="mt-[100px] text-center text-sm text-gray-500">
            Nothing to see here... yet!
          </p>
        </div>
      )}
    </TabsContent>
  )
}

export default NotificationsList
